export default __webpack_public_path__ + "static/media/logo.d421581f.png";